import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HTMLBounds } from 'src/app/components/image/model';
import { TutorialHighlightService } from '../tutorial-highlight.service';

@Component({
  selector: 'tutorial-highlight',
  templateUrl: './tutorial-highlight.component.html',
  styleUrls: ['./tutorial-highlight.component.scss'],
  standalone: false,
})
export class TutorialHighlightComponent implements OnInit {
  @ViewChild('overlay') overlay: ElementRef<HTMLDivElement>;

  get highlightElement(): HTMLElement {
    return this.tutorialHighlight?.element;
  }

  get containerWidth() {
    if (!this.overlay?.nativeElement) {
      return;
    }
    return this.overlay.nativeElement.getBoundingClientRect().width;
  }

  get containerHeight() {
    if (!this.overlay?.nativeElement) {
      return;
    }
    return this.overlay.nativeElement.getBoundingClientRect().height;
  }

  get leftOverlay(): HTMLBounds {
    if (!this.highlightElement || !this.overlay?.nativeElement) {
      return;
    }
    return {
      left: 0,
      top: this.highlightElement.getBoundingClientRect().top,
      right: this.containerWidth - this.highlightElement.getBoundingClientRect().right,
      bottom: this.containerHeight - this.highlightElement.getBoundingClientRect().bottom,
    };
  }

  get topOverlay(): HTMLBounds {
    if (!this.highlightElement || !this.overlay?.nativeElement) {
      return;
    }
    let bottom = this.highlightElement.getBoundingClientRect().bottom;
    let height = this.highlightElement.getBoundingClientRect().height;
    let ret = {
      left: 0,
      top: 0,
      right: 0,
      height: this.highlightElement.getBoundingClientRect().top,
    };
    return ret;
  }

  get rightOverlay(): HTMLBounds {
    if (!this.highlightElement || !this.overlay?.nativeElement) {
      return;
    }
    return {
      left: this.containerWidth - this.highlightElement.getBoundingClientRect().left,
      top: this.highlightElement.getBoundingClientRect().top,
      right: 0,
      bottom: this.containerHeight - this.highlightElement.getBoundingClientRect().bottom,
    };
    return;
  }

  get bottomOverlay(): HTMLBounds {
    if (!this.highlightElement || !this.overlay?.nativeElement) {
      return;
    }
    return {
      left: 0,
      top: this.highlightElement.getBoundingClientRect().bottom,
      right: 0,
      bottom: 0,
    };
  }

  constructor(public tutorialHighlight: TutorialHighlightService) {}

  ngOnInit(): void {}

  hideOverlay(): void {
    this.tutorialHighlight.hide();
  }
}
